import { render } from "./manage-surveys.vue?vue&type=template&id=f81dc8ac"
import script from "./manage-surveys.vue?vue&type=script&lang=js"
export * from "./manage-surveys.vue?vue&type=script&lang=js"

import "./manage-surveys.vue?vue&type=style&index=0&id=f81dc8ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__